import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import posed from "react-pose";
import { t } from "@lingui/macro";
import { i18n } from "idc-ui-react";
import useLocalStorage from "react-use/lib/useLocalStorage";
// Fluent UI
import { Stack, Text, PrimaryButton, Icon, Link } from "@fluentui/react";
// Our modules
import { MoreLink, Section, ProfileBadge } from "../../../components";

const PoseAnimationContainer = posed.div({
  hidden: { height: 0 },
  visible: { height: "auto" }
});

const ProfileToggle = ({ profile }) => {
  const {
    name,
    userName,
    positions: [position],
    thumbnail
  } = profile;

  const [isVisible, setIsVisible] = useLocalStorage("badgeVisible", true);
  const [greeting, setGreeting] = useState("");

  useEffect(() => {
    const hour = new Date().getHours();

    if (hour > 17 && hour < 23) {
      setGreeting(i18n._(t`Good evening`));
    } else if (hour > 14) {
      setGreeting(i18n._(t`Good afternoon`));
    } else if (hour > 5 && hour < 10) {
      setGreeting(i18n._(t`Good morning`));
    } else {
      setGreeting(i18n._(t`Welcome`));
    }
  }, []);

  return (
    <Section hero={true} slide="right">
      <PoseAnimationContainer
        style={{ overflow: "hidden" }}
        pose={isVisible ? "visible" : "hidden"}
      >
        <Text variant="xLargePlus">{greeting},</Text>
        <Stack styles={{ root: { marginTop: "20px" } }}>
          <ProfileBadge
            username={userName}
            name={name.fullName}
            position={position}
            imageUrl={thumbnail}
            size={72}
          />
        </Stack>
        <MoreLink link="/profile" text={i18n._(t`View your profile`)} />
      </PoseAnimationContainer>
      <PoseAnimationContainer
        style={{ overflow: "hidden" }}
        pose={isVisible ? "hidden" : "visible"}
      >
        <Link as={RouterLink} to="/profile">
          <PrimaryButton
            iconProps={{ iconName: "ChevronRight" }}
            text={i18n._(t`View your profile`)}
            ariaDescription={i18n._(t`View your profile`)}
          />
        </Link>
      </PoseAnimationContainer>
      <Stack
        horizontal
        styles={{
          root: {
            position: "absolute",
            top: 16,
            right: 4,
            cursor: "pointer",
            fontSize: 9,
            color: "#605e5c"
          }
        }}
        onClick={() => setIsVisible(!isVisible)}
      >
        <Text variant="small">
          <Icon
            iconName={isVisible ? "ChevronUp" : "ChevronDown"}
            styles={{ root: { marginRight: 7 } }}
          />
          {isVisible ? i18n._(t`Hide Info Badge`) : i18n._(t`Show Info Badge`)}
        </Text>
      </Stack>
    </Section>
  );
};

export default ProfileToggle;
